import _ from 'lodash'
import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'

/**
 * Provides the values and resource bundle keys for Java enumerations.  For
 * example,
 *
 * enums.missingValueTreatment['not-applicable'] ===
 * 'scorecard.builder.metric.missingValues.notApplicable'
 */
var enums = {

	/**
	 * Returns an array of objects suitable for building option dropdowns for
	 * a given enum type
	 *
	 * @param {String} type the enum type to generate the option data
	 * @param {Array} [icons] array of icon names to associate with each element
	 * in the returned array
	 * @returns {Array} array of objects with each with an id and label
	 */
	toOptionData: function(type, icons = []) {
		let i = 0
		return _.map(enums[type], (label, id) => ({id, label: i18n.get(label),
			icon: _.get(icons, `[${i++}]`)
		}))
	},

	/**
	 * Creates a list of label/value pairs that can be used for {@link LabeledToggle}
	 * @param {String} type enum type to generate toggle data
	 * @returns {Array} array of objects with each with an label and value
	 */
	toToggleData: function(type) {
		return _.map(enums[type], (label, id) => ({
			label: i18n.get(label),
			value: id
		}))
	}
}

Backbone.on('load', function(data) {
	if (data.enums) {
		_.extend(enums, data.enums)
	}
})

export default enums

enums.__filename__ = 'components/enums.js'
